app.service('accountWarrantiesManager', function (front, pageConfig, modal, upsellingWarranties) {
	let $body, $warrantiesOrderPreview, $warrantiesOrderList;

	function init() {
		setElements();

		if (!pageConfig.getData('account').guestLogged) {
			upsellingWarranties.init();

			if (front.page() === "order-preview") {
				if (!$warrantiesOrderPreview.length) {
					return;
				}
				$body.addClass('account-warranties-loading');
				upsellingWarranties.loadAvailableWarrantiesForPreview()
					.then(response => $warrantiesOrderPreview.html(response))
					.always(() => $body.removeClass('account-warranties-loading'));
			}

			if (front.page() === "account-main-page" || front.page() === "order-list-active") {
				if (!pageConfig.getData('account').isUserLogged || pageConfig.getData('operator').isLogged) {
					return;
				}
				if (!$warrantiesOrderList.length) {
					return;
				}

				$body.addClass('account-warranties-loading');

				upsellingWarranties.loadUpsellingWarranties()
					.then(upsellingWarrantiesHtml => {
						$warrantiesOrderList.append(upsellingWarrantiesHtml)
					})
					.fail(() => {
						$warrantiesOrderList.html(
							"<div class='error-message'>Wystąpił błąd podczas ładowania listy gwarancji. Odśwież stronę lub spróbuj ponownie później.</div>"
						);
					})
					.always(() => $body.removeClass('account-warranties-loading'));
			}
		}
	}

	function setElements() {
		$body = $('body');
		$warrantiesOrderPreview = $('#order-preview-warranties', $body);
		$warrantiesOrderList = $('#order-list-warranties', $body);
	}

	return {
		init
	};
});